import { jsx as a, jsxs as m } from "react/jsx-runtime";
import { useState as f, useEffect as i } from "react";
import { classes as l } from "../../utils/helpers.js";
import { pageHeroLayoutsMap as p } from "../../settings.js";
import { s as u } from "../../PageHero.module-BdV8z_Xv.mjs";
function x({ layoutComponent: e = "", layoutProps: s = {}, children: o }) {
  const [r, t] = f(null);
  return i(() => {
    t(p.get(e));
  }, [e]), /* @__PURE__ */ a("section", { className: l([u["page-hero"], "page-hero"]), children: r !== null && /* @__PURE__ */ m(r, { ...s, children: [
    " ",
    o,
    " "
  ] }) });
}
export {
  x as PageHero,
  x as default
};
